const toNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export const getTemplateSerial = (template) => {
  const serial = toNumber(template?.serial);
  if (serial && serial > 0) return serial;

  const id = toNumber(template?.id);
  return id && id > 0 ? id : 1;
};

export const sortTemplatesBySerial = (templates = []) => {
  return [...templates].sort((a, b) => {
    const serialDiff = getTemplateSerial(a) - getTemplateSerial(b);
    if (serialDiff !== 0) return serialDiff;

    return (toNumber(a?.id) || 0) - (toNumber(b?.id) || 0);
  });
};

export const getTemplateBySerial = (templates = [], serial) => {
  const serialNum = toNumber(serial);
  if (!serialNum) return null;

  return (
    templates.find((template) => getTemplateSerial(template) === serialNum) ||
    null
  );
};

export const getTemplateForRecord = (templates = [], templateIdOrSerial) => {
  const value = toNumber(templateIdOrSerial);
  if (!value) return null;

  return (
    templates.find((template) => toNumber(template?.id) === value) ||
    getTemplateBySerial(templates, value)
  );
};

export const getComponentByTemplate = (template, components = []) => {
  if (!template || components.length === 0) return null;

  const serial = getTemplateSerial(template);
  const index = Math.max(0, (serial - 1) % components.length);
  return components[index] || null;
};
